import { render, staticRenderFns } from "./sales-quote.vue?vue&type=template&id=62dd3390&"
import script from "./sales-quote.vue?vue&type=script&lang=js&"
export * from "./sales-quote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports